import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

interface FadeInSectionProps {
  children: React.ReactNode;
  className?: string;
  threshold?: number;
  initialVisible?: boolean;
}

const FadeInSection: React.FC<FadeInSectionProps> = ({
  children,
  className = '',
  threshold = 0.1,
  initialVisible = false
}) => {
  const { ref, isVisible } = useScrollAnimation(threshold, initialVisible);

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={`transition-all duration-800 ${
        isVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'
      } ${className}`}
    >
      {children}
    </section>
  );
};

export default FadeInSection;